import React, { Component } from 'react';
import withTracking from '../../../../utils/tracking/components/withTracking';
import {
  defaultClick,
  widgetImpression
} from '../../../../utils/tracking/events/pageEvents';
import EventModel from '../../../../utils/tracking/models';
import Waypoint from 'react-waypoint';
import PropTypes from 'prop-types';
import { get } from 'lodash';
/* eslint-disable react/no-did-mount-set-state */

class Notice extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: true,
      message1: get(props, 'homepageTopPromo.text_1', ''),
      message2: get(props, 'homepageTopPromo.text_2', ''),
      link: get(props, 'homepageTopPromo.link', ''),
      name: get(props, 'homepageTopPromo.name', '')
    };

    this.closeNotice = this.closeNotice.bind(this);
    this.cleanText = this.cleanText.bind(this);
    this.handlePromoBarClick = this.handlePromoBarClick.bind(this);
    this.handleWidgetImpression = this.handleWidgetImpression.bind(this);
  }

  componentDidMount() {
    // this.setState({ show: document.cookie.indexOf('fc_notice_closed') === -1 });

    setInterval(() => {
      if (this.state.show) {
        if (
          document.querySelector('.slide.slide1').classList.contains('show')
        ) {
          document
            .querySelector('.slide.slide1')
            .classList.replace('show', 'hide');
          document
            .querySelector('.slide.slide2')
            .classList.replace('hide', 'show');
        } else if (
          document.querySelector('.slide.slide1').classList.contains('hide')
        ) {
          document
            .querySelector('.slide.slide1')
            .classList.replace('hide', 'show');
          document
            .querySelector('.slide.slide2')
            .classList.replace('show', 'hide');
        }
      }
    }, 3000);
  }

  closeNotice() {
    document.cookie = 'fc_notice_closed';
    this.setState({ show: false });
  }

  cleanText(data) {
    const regex = /(<([^>]+)>)/gi;
    const body = `${data}`;
    const result = body.replace(regex, '');
    return result;
  }

  handlePromoBarClick(data) {
    const name = this.cleanText(data);
    const clickEvent = new EventModel(
      name || 'none',
      `topPromotionBar`,
      `click`,
      `nav ${name || 'none'}`,
      `topOfPage`
    );
    this.props.trackClick(clickEvent.getTrackingObject());
  }

  handleWidgetImpression(promoName) {
    const impressionEvent = new EventModel(
      `${promoName || 'none'}`,
      `topPromotionBar`,
      `impression`,
      `nav ${promoName || 'none'}`,
      `topOfPage`
    );
    this.props.trackImpression(impressionEvent.getTrackingObject());
  }

  render() {
    if (!this.state.show) {
      return false;
    }
    return (
      <section className="notice">
        <Waypoint
          onEnter={() => {
            this.handleWidgetImpression(this.state.name);
          }}
        />
        <div className="inner">
          <div
            className="slide slide1 show"
            onClick={() => {
              this.handlePromoBarClick(this.state.name);
            }}
          >
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={this.state.link}
              dangerouslySetInnerHTML={{ __html: this.state.message1 }}
            />
          </div>

          <div
            className="slide slide2 hide"
            onClick={() => {
              this.handlePromoBarClick(this.state.name);
            }}
          >
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={this.state.link}
              dangerouslySetInnerHTML={{ __html: this.state.message2 }}
            />
          </div>

          <div
            className="close"
            onClick={() => {
              this.closeNotice();
            }}
          >
            <img
              src="https://images.fastcompany.net/image/upload/v1599849526/fcweb/ex_ndgqh7.svg"
              alt="X"
            />
          </div>
        </div>
      </section>
    );
  }
}

Notice.defaultProps = {
  trackImpression: {},
  trackClick: {}
};

Notice.propTypes = {
  trackImpression: PropTypes.func,
  trackClick: PropTypes.func
};

const mapTrackingToProps = trackEvent => ({
  trackClick: pageObject => trackEvent(defaultClick(pageObject)),
  trackImpression: pageObject => trackEvent(widgetImpression(pageObject))
});

const trackedNotice = withTracking(mapTrackingToProps)(Notice);

export default trackedNotice;
